<div class="driver-success-model">
    <img src="assets/images/driver-success.png" alt="Success"/>
    <h4>Success!</h4>
    <p>{{config?.data?.successMessage}}</p>
    <div class="btn-outer">
        <p-button label="OK"  (onClick)="cancelDialog()"/>
    </div>
</div>